export default __webpack_public_path__ + "static/media/3. Dartmouth Common App Essay.f4c3b54e.pdf";